import { HardwareDevUid, HardwareInfo } from "./HardwareInfoComp";

export const SingleHardware = {
    DevUID : HardwareDevUid,
    Info:  HardwareInfo
}

export default SingleHardware